<template>
  <div class="chat-widget-template-slider">
    <button
      v-show="canScrollLeft"
      type="button"
      class="chat-widget-template-slider__arrow chat-widget-template-slider__arrow--left"
      @click="scrollBy(-1)"
    >
      <i class="bi bi-chevron-left" />
    </button>
    <div
      ref="track"
      class="chat-widget-template-slider__track"
      @scroll="updateArrows"
    >
      <button
        v-for="tpl in templates"
        :key="tpl.id"
        class="chat-widget-template-slider__card"
        :disabled="disabled"
        @click="$emit('action', 'open_showcase:' + tpl.id)"
      >
        <div class="chat-widget-template-slider__thumb">
          <img
            :src="tpl.thumbnail"
            :alt="tpl.name"
            class="chat-widget-template-slider__img"
          >
        </div>
        <div class="chat-widget-template-slider__info">
          <div class="chat-widget-template-slider__name">
            {{ getStyleLabel(tpl) || tpl.name }}
          </div>
          <div class="chat-widget-template-slider__meta">
            {{ getTypeLabel(tpl) }}<span v-if="getTypeLabel(tpl)"> &middot; </span>{{ tpl.width }}&times;{{ tpl.height }}
          </div>
        </div>
      </button>
    </div>
    <button
      v-show="canScrollRight"
      type="button"
      class="chat-widget-template-slider__arrow chat-widget-template-slider__arrow--right"
      @click="scrollBy(1)"
    >
      <i class="bi bi-chevron-right" />
    </button>
  </div>
</template>

<script>
import {
  getPrimaryTypeKey,
  getStyleKeys,
  styleKeyToLabel,
  typeKeyToLabel,
} from '@frontend/store/creative-studio/template-showcase-tags';

export default {
  name: 'AIChatWidgetTemplateSlider',
  props: {
    templates: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      canScrollLeft: false,
      canScrollRight: false,
    };
  },
  mounted() {
    this.$nextTick(this.updateArrows);
  },
  methods: {
    getStyleLabel(tpl) {
      const key = getStyleKeys(tpl.tags)[0] || '';
      return key ? styleKeyToLabel(key) : '';
    },
    getTypeLabel(tpl) {
      const key = getPrimaryTypeKey(tpl.tags) || '';
      return key ? typeKeyToLabel(key) : '';
    },
    scrollBy(direction) {
      const track = this.$refs.track;
      if (!track) return;
      track.scrollBy({ left: direction * 360, behavior: 'smooth' });
    },
    updateArrows() {
      const track = this.$refs.track;
      if (!track) return;
      this.canScrollLeft = track.scrollLeft > 0;
      this.canScrollRight = track.scrollLeft + track.clientWidth < track.scrollWidth - 2;
    },
  },
};
</script>

<style lang="scss" scoped>
.chat-widget-template-slider {
  margin-top: 10px;
  position: relative;
  overflow: hidden;
  width: 0;
  min-width: 100%;
}
.chat-widget-template-slider__track {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  padding: 4px 4px 8px;

  &::-webkit-scrollbar {
    height: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 4px;
  }
}
.chat-widget-template-slider__arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1px solid #e5e7eb;
  background: #fff;
  color: #334155;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  font-size: 12px;

  &:hover {
    background: #f1f5f9;
  }
  &--left {
    left: -6px;
  }
  &--right {
    right: -6px;
  }
}
.chat-widget-template-slider__card {
  flex: 0 0 170px;
  scroll-snap-align: start;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #fff;
  overflow: hidden;
  cursor: pointer;
  transition: box-shadow 0.2s, border-color 0.2s;
  padding: 0;
  text-align: left;

  &:hover:not(:disabled) {
    border-color: #379C75;
    box-shadow: 0 4px 16px rgba(55, 156, 117, 0.15);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}
.chat-widget-template-slider__thumb {
  width: 100%;
  height: 120px;
  background: #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.chat-widget-template-slider__img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
.chat-widget-template-slider__info {
  padding: 8px 10px;
}
.chat-widget-template-slider__name {
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.chat-widget-template-slider__meta {
  font-size: 11px;
  color: #64748b;
  margin-top: 2px;
}
</style>
